module.exports = __webpack_public_path__ + "media/images/keyVisual_mobile_zh-hans-b5e965b2d914d1bedc30d84f3c1e0b54.jpg";